module.exports = __webpack_public_path__ + "static/img/icon_sass.365c6025.svg";